module.exports = __webpack_public_path__ + "media/images/ns_logo_final_wht_screen-bae887ac11e46a8c712351a7321b5307.png";